import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { handleForgotPassword, openModal, resetForgotPassword } from '../../redux/actions';
import SlideInModal from "../../containers/SlideInModal";
import InputList from '../InputList';
import Input from '../Input';

import { FormFooter, LoginButton, SignUpButton, ErrorMessage, SuccessMessage } from './styles';

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const ForgotSchema = Yup.object().shape({
  email: Yup.string()
    .matches(emailRegex, 'Invalid email')
    .required('Email is required'),
});

const { Item } = InputList;
const { Heading, Description } = SlideInModal;

const ForgotModal = ({
  name,
  handleUserForgot,
  forgotError,
  handleLoginModalCall,
  forgotSuccess,
  handleResetForgot,
}) => (
  <SlideInModal name={name}>
    <Heading>
      Forgot your password?
    </Heading>
    <Description>
      Enter your email and a password reset link will be sent to you
    </Description>
    {forgotSuccess ? (
      <Fragment>
        <SuccessMessage style={{ marginBottom: 40 }}>
          A password reset link has been sent to your email address
        </SuccessMessage>
        <LoginButton style={{ width: 140 }} type="button" btnType="primary" onClick={() => { handleResetForgot(); handleLoginModalCall('login'); }}>
          Done
        </LoginButton>
      </Fragment>
    ) : (
      <Formik
        initialValues={{
          email: '',
        }}
        validationSchema={ForgotSchema}
        onSubmit={values => handleUserForgot(values)}
      >
        {({ errors, touched, handleBlur, handleChange, values }) => (
          <Form>
            <InputList>
              <Item>
                <Input
                  htmlType="text"
                  name="email"
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  value={values.email}
                  hasError={errors.email && touched.email}
                  placeholder={errors.email || 'Enter email'}
                  floatingPlaceholder
                />
              </Item>
            </InputList>
            {forgotError && <ErrorMessage>{forgotError}</ErrorMessage>}
            <FormFooter>
              <LoginButton type="submit" btnType="primary">
                Reset Password
              </LoginButton>
              <SignUpButton type="button" onClick={() => handleLoginModalCall('login')}>
                Remembered password?
              </SignUpButton>
            </FormFooter>
          </Form>
        )}
      </Formik>
    )}
  </SlideInModal>
);

ForgotModal.propTypes = {
  name: PropTypes.string.isRequired,
  forgotError: PropTypes.string,
  handleUserForgot: PropTypes.func,
  handleLoginModalCall: PropTypes.func,
  forgotSuccess: PropTypes.bool,
};

const mapStateToProps = state => ({
  forgotSuccess: state.user.success.forgot,
  forgotError: state.user.errors.forgot,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      handleUserForgot: handleForgotPassword,
      handleLoginModalCall: openModal,
      handleResetForgot: resetForgotPassword,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotModal);
